import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { Menu } from '../../models/generic/Menu';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Aliados } from '../../models/generic/Aliados';
import { Canales } from '../../models/generic/Canales';
import { Listas } from 'src/app/models/generic/Listas';
import { Producto } from 'src/app/models/generic/Producto';
import { SeleccionAliadoCanalMenu } from 'src/app/models/generic/SeleccionAliadoCanalMenu';

@Component({
  selector: 'seleccionaliadocanal',
  templateUrl: './seleccionaliadocanal.component.html',
  styleUrls: ['./seleccionaliadocanal.component.scss']
})
export class SeleccionAliadoCanalComponent implements OnInit{
  TituloMostrar: string = 'Selección requerida';
  TextoSiMostrar: string = 'Aceptar';
  TextoNoMostrar: string = 'Cancelar';
  CodigoLlamado: string = '';
  @Output() CambioAliadoCanal: EventEmitter<boolean>;
  @Output() SeleccionoAliadoCanal: EventEmitter<SeleccionAliadoCanalMenu>;
  @ViewChild('modalconfirmacion', {static: false}) _ModalConfirmacion: TemplateRef<any>;
  
  _MensajeMostrarAliadoCanal: string = 'Por favor seleccione el aliado y el canal para abrir la opción';
  _MensajeMostrarAliado: string = 'Por favor seleccione el aliado para abrir la opción';
  _HabilitarAliado: boolean;
  _MostrarCanal: boolean;
  form: FormGroup;
  _ListaAliados: Aliados[];
  _ListaCanales: Canales[];
  mostrarCargando: boolean = false;
  seleccionAliadoCanalMenu: SeleccionAliadoCanalMenu = new SeleccionAliadoCanalMenu();


  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public configuracionService: ConfiguracionService,
    public autenticacionService: AutenticacionService,
    public productosService: ProductosService,
    public modal: MatDialog) {
      this.SeleccionoAliadoCanal = new EventEmitter();
      this.CambioAliadoCanal = new EventEmitter();
    }

  ngOnInit() {
    
  }

  public MostrarMensajeConfirmacion(menuSeleccionado: Menu) {
    this.mostrarCargando = false;

    if (menuSeleccionado.requiereCanal) {
      this._MostrarCanal = true;
      this.TituloMostrar = this._MensajeMostrarAliadoCanal;

      this.form = this.fb.group({
        aliado: [0, [Validators.required, Validators.min(1)]],
        canal: [0, [Validators.required, Validators.min(1)]]
      });
    } else {
      this._MostrarCanal = false;
      this.TituloMostrar = this._MensajeMostrarAliado;

      this.form = this.fb.group({
        aliado: [0, [Validators.required, Validators.min(1)]],
        canal: [0, Validators.required]
      });
    }

    this._ListaAliados = this.autenticacionService.UsuarioActivo.listaAliados;
    this.seleccionAliadoCanalMenu.menu = menuSeleccionado;

    this.modal.open(this._ModalConfirmacion);

    if (this.utilitariosService.VerificarContieneDatosNumerico(this.autenticacionService.AliadoSeleccionado)) {
      this.form.get('aliado').setValue(this.autenticacionService.AliadoSeleccionado);
      this.ConsultarCanales(this.form.get('aliado').value);
      
      if (this._ListaCanales.length === 1) {
        this.AsignarValoresAutenticacion();
      }
    }

    if (this._ListaAliados.length > 1) {
      this._HabilitarAliado = true;
    } else {
      this._HabilitarAliado = false;
    }

    this.form.get('aliado').valueChanges.subscribe((valorNuevo) => {
      this.ConsultarCanales(valorNuevo);
    });
  }
  public MostrarSeleccionAliadoCanal(requiereCanal: boolean) {
    this.mostrarCargando = false;

    if (requiereCanal) {
      this._MostrarCanal = true;
      this.TituloMostrar = this._MensajeMostrarAliadoCanal;

      this.form = this.fb.group({
        aliado: [0, [Validators.required, Validators.min(1)]],
        canal: [0, [Validators.required, Validators.min(1)]]
      });
    } else {
      this._MostrarCanal = false;
      this.TituloMostrar = this._MensajeMostrarAliado;

      this.form = this.fb.group({
        aliado: [0, [Validators.required, Validators.min(1)]],
        canal: [0, Validators.required]
      });
    }

    this._ListaAliados = this.autenticacionService.UsuarioActivo.listaAliados;
    this.seleccionAliadoCanalMenu.menu = null;

    this.modal.open(this._ModalConfirmacion);

    if (this.utilitariosService.VerificarContieneDatosNumerico(this.autenticacionService.AliadoSeleccionado)) {
      this.form.get('aliado').setValue(this.autenticacionService.AliadoSeleccionado);
      this.ConsultarCanales(this.form.get('aliado').value);
    }

    if (this._ListaAliados.length > 1) {
      this._HabilitarAliado = true;
    } else {
      this._HabilitarAliado = false;
    }

    this.form.get('aliado').valueChanges.subscribe((valorNuevo) => {
      this.ConsultarCanales(valorNuevo);
    });
  }
  ConsultarCanales(idAliado: number) {
    let aliado = this._ListaAliados.filter(x => x.idAliado === idAliado);
    this._ListaCanales = aliado[0].listaCanales;
    if (this._ListaCanales.length === 1) {
      this.form.get('canal').setValue(this._ListaCanales[0].idCanal);
    }
  }
  SeleccionoInformacion() {
    if (this.form.valid) {
      this.CambioAliadoCanal.emit(true);
      this.mostrarCargando = true;

      let formConsulta = this.fb.group({
        idAplicacion: 0
      });
      let aliadoSeleccionado = this._ListaAliados.filter(x => x.idAliado === this.form.get('aliado').value);
      formConsulta.get('idAplicacion').setValue(aliadoSeleccionado[0].idAplicacion);
      
      this.configuracionService.CargarListas(formConsulta.value).subscribe((resp: Listas[]) => {
        this.configuracionService.ListasSistema = resp;
        this.CargarProductos();
      },(error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
    }
  }
  CargarProductos() {
    if (this._MostrarCanal) {
      let formConsulta = this.fb.group({
        idAplicacion: 0,
        idCanal: 0
      });
      let aliadoSeleccionado = this._ListaAliados.filter(x => x.idAliado === this.form.get('aliado').value);
      formConsulta.get('idAplicacion').setValue(aliadoSeleccionado[0].idAplicacion);
      formConsulta.get('idCanal').setValue(this.form.get('canal').value);

      this.productosService.CargarProductosVentas(formConsulta.value).subscribe((resp: Producto[]) => {
        this.productosService.ListaProductos = resp;
        this.AsignarValoresAutenticacion();
      },(error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
    } else {
      let formConsulta = this.fb.group({
        idAplicacion: 0
      });
      this.productosService.CargarProductos(formConsulta.value, 'desdeseleccioncanal').subscribe((resp: Producto[]) => {
        this.productosService.ListaProductos = resp;
        this.AsignarValoresAutenticacion();
      },(error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
    }
  }
  NoSeleccionoInformacion() {
    this.modal.closeAll();
    this.seleccionAliadoCanalMenu.confirmoUsuario = false;
    this.SeleccionoAliadoCanal.emit(this.seleccionAliadoCanalMenu);
  }
  AsignarValoresAutenticacion() {
    let aliadoSeleccionado = this._ListaAliados.filter(x => x.idAliado === this.form.get('aliado').value);
    this.autenticacionService.AplicacionSeleccionado = aliadoSeleccionado[0].idAplicacion;
    this.autenticacionService.AliadoSeleccionado = aliadoSeleccionado[0].idAliado;
    this.autenticacionService.DescripcionAliadoSeleccionado = aliadoSeleccionado[0].aliado;
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('canal').value)) {
      this.autenticacionService.ListaCanales = aliadoSeleccionado[0].listaCanales;
      let canalSeleccionado = aliadoSeleccionado[0].listaCanales.filter(x => x.idCanal === this.form.get('canal').value);

      this.autenticacionService.CanalSeleccionado = canalSeleccionado[0].idCanal;
      this.autenticacionService.DescripcionCanalSeleccionado = canalSeleccionado[0].canal;
    }
    
    this.modal.closeAll();
    this.seleccionAliadoCanalMenu.confirmoUsuario = true;
    this.SeleccionoAliadoCanal.emit(this.seleccionAliadoCanalMenu);
  }
}
